var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Updates-Dec-2021",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Change-Card",
    transform: "translate(-700.000000, -233.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(470.000000, 203.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(230.000000, 30.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,0 C8.96,0 0,8.96 0,20 C0,31.04 8.96,40 20,40 C31.04,40 40,31.04 40,20 C40,8.96 31.04,0 20,0 Z",
    id: "Shape",
    fill: "#6E7CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.127012,14.8437575 C31.1598109,14.8437575 32,15.6839935 32,16.7167924 L32,16.7167924 L32,27.3242038 C32,28.3570027 31.159764,29.1972387 30.1269651,29.1972387 L30.1269651,29.1972387 L13.6699173,29.1972387 C12.6371184,29.1972387 11.7968824,28.3570027 11.7968824,27.3242038 L11.7968824,27.3242038 L11.7968824,26.7597339 L26.3301296,26.7597339 C28.1383362,26.7597339 29.6094172,25.2886529 29.6094172,23.4804463 L29.6094172,23.4804463 L29.6094172,14.8437575 Z M28.2031645,18.8281872 L28.2031645,23.4804931 C28.2031645,24.513292 27.3629284,25.353528 26.3300827,25.353528 L26.3300827,25.353528 L9.87303491,25.353528 C8.84023602,25.353528 8,24.513292 8,23.4804931 L8,23.4804931 L8,18.8281872 L28.2031645,18.8281872 Z M28.2031645,16.0156348 L28.2031645,17.4218875 L8,17.4218875 L8,16.0156348 L28.2031645,16.0156348 Z M26.3301296,11 C27.3629284,11 28.2031645,11.840236 28.2031645,12.8730349 L28.2031645,12.8730349 L28.2031645,14.609382 L8,14.609382 L8,12.8730349 C8,11.840236 8.84023602,11 9.87303491,11 L9.87303491,11 Z",
    id: "Profiles",
    fill: "#FFFFFF"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.8576ecae44a816440b705e81ffe7f5b1.svg";
export { ForwardRef as ReactComponent };